export class LogonStatusData {
  code?: string;
  parentUserUuid?: string;

  static of(statusData: any): LogonStatusData {
    let logonStatus = null;
    if (statusData) {
      logonStatus = new LogonStatusData();
      logonStatus.code = statusData.code ?? null;
      logonStatus.parentUserUuid = statusData.parentUserUuid ?? null;
    }

    return logonStatus;
  }
}
